/**
 * Created by jonas on 2021-02-19.
 */


export interface SimplePresentationRunnerController {
    finish:()=>void,
    setSkipCallback:(skipCallback?:Function)=>void
}

export interface SimplePresentation{
    start(controller:SimplePresentationRunnerController):void;
    shouldRun():boolean;
}

export class SimplePresentationRunner {
    public static run(presentations:SimplePresentation[], finishCallback:Function, setSkipCallback:(skipCallback?:Function)=>void){
        const localPresentations = presentations.concat();
        const presentation:SimplePresentation | undefined = localPresentations.shift();
        if (presentation == undefined){
            finishCallback();
        } else {
            if (presentation.shouldRun()){
                presentation.start({
                    finish:()=>SimplePresentationRunner.run(localPresentations,finishCallback, setSkipCallback),
                    setSkipCallback:setSkipCallback
                });
            }  else {
                SimplePresentationRunner.run(localPresentations,finishCallback, setSkipCallback)
            }
        }
    }
}